import { DashboardCard } from "@dashboard/components/Card";
import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";

/**
 * The right rail every compose detail page carries. Stock detail pages cap the
 * form at about 740px and fill the rest with context; without one these screens
 * ran a four-character field across 555px and left 300px of white under it.
 */
export const WsmRail = ({
  title,
  testId,
  children,
}: {
  title: string;
  testId: string;
  children: React.ReactNode;
}) => (
  <DashboardCard data-test-id={testId}>
    <DashboardCard.Header>
      <DashboardCard.Title>{title}</DashboardCard.Title>
    </DashboardCard.Header>
    <DashboardCard.Content>
      <Box display="grid" gap={4}>
        {children}
      </Box>
    </DashboardCard.Content>
  </DashboardCard>
);

export const WsmRailRow = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <Box display="grid" gap={1}>
    <Text size={2} color="default2">
      {label}
    </Text>
    {typeof children === "string" ? <Text size={3}>{children}</Text> : <Box>{children}</Box>}
  </Box>
);

export default WsmRail;
